import { createSlice } from "@reduxjs/toolkit";

const producvuSlice = createSlice({
  name: "producvu",
  initialState: {
    checkedRows: [],
    ischeckedAll: false,
    searchValue: "",
  },
  reducers: {
    setCheckedRows: (state, action) => {
      state.checkedRows = action.payload;
    },
    setIscheckedAll: (state, action) => {
      state.ischeckedAll = action.payload;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    resetCheckedRows: (state) => {
      state.checkedRows = [];
      state.ischeckedAll = false;
    },
  },
});

export const { setCheckedRows, setIscheckedAll, resetCheckedRows, setSearchValue } = producvuSlice.actions;
export default producvuSlice.reducer;

export const getCheckedRows = (state) => {
  return state.producvu.checkedRows;
};

export const getSearchValue = (state) => {
  return state.producvu.searchValue;
};

export const getIsChekedAll = (state) => {
  return state.producvu.ischeckedAll;
};
